module.exports = __webpack_public_path__ + "static/img/8.41f10b2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/2/zh/8.png
// module id = 6Njr
// module chunks = 0